import { Divider } from "@mui/material";
import menuItem from "menu-items";
import albums from "menu-items/albums";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import NavGroup from "./NavGroup";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const ALBUM_REGEX = /\/albums\/(\d)([\w,\W,\/]*)/;
const MenuList = () => {
  const album = useSelector((state) => state.albums.album);
  const { data } = useSelector((state) => state.dashboard.photograph);
  const location = useLocation();
  let menus = [menuItem.dashboard(data)];
  if (album && location.pathname.match(ALBUM_REGEX)) {
    menus = [...menus, albums(album)];
  }
  const navItems = menus.map((item) => {
    switch (item.type) {
      case "divider":
        return <Divider key={item.id} />;
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        throw new Error("Unkown item type");
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
